<template>
  <div id="square5">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Square',
};
</script>

<style lang="scss">
#square5 {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 44px;
  width: 44px;
  transform: translate(-50%, -50%);
  z-index: 5;
}

#square5 span {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: #000;
  display: inline-block;
  -webkit-animation: square5 1.7s infinite ease-in-out both;
  animation: square5 1.7s infinite ease-in-out both;
}

#square5 span:nth-child(1) {
  top: 0;
  left: 0;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
  background: $icims-primary;
}

#square5 span:nth-child(2) {
  top: 0;
  right: 0;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
  background: $secondary;
}

#square5 span:nth-child(3) {
  bottom: 0;
  left: 0;
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
  background: $crimson;
}

#square5 span:nth-child(4) {
  bottom: 0;
  right: 0;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
  background: $purple;
}

@keyframes square5 {
  0% {
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  50% {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }
  100% {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
  }
}

@-webkit-keyframes square5 {
  0% {
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  50% {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }
  100% {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
  }
}
</style>
